import { Api } from "../config/request";

export default {
  getCountry(payload) {
    const id = payload.id;
    return Api.get(`/locations/country/${id}`);
  },
  createCountry(payload) {
    return Api.post("/locations/country", payload);
  },
  getCountryList(qs) {
    return Api.get(`/locations/country${qs && qs.length > 0 ? `?${qs}` : ""}`);
  },
  updateCountry(id, payload) {
    return Api.put(`/locations/country/${id}`, payload);
  },
  deleteCountry(payload) {
    const id = payload.country_id;
    return Api.post(`/locations/country/${id}/delete`);
  },
};
